exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2nPgg{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.wave>div{margin:0 2px}", ""]);

// exports
exports.locals = {
	"wrapper": "_2nPgg"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[hash:base64:5]!./~/postcss-loader!./client/app/components/loading/style.css
 ** module id = 224
 ** module chunks = 0
 **/